import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import gql from 'graphql-tag';
import { ToastService } from 'ng-uikit-pro-standard';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { RutValidator } from 'ng9-rut';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { rol } from '../../../shared/object/roles.model';
import { sucursal } from '../../../shared/object/sucursal.model';
import { sucursal_usuario } from '../../../shared/object/sucursal_usuario.model';
import { sucursal_usuarioJoin } from '../../../shared/object/sucursal_usuarioJoin.model';
import { usuario } from '../../../shared/object/usuario.model';
import { usuario_rol } from '../../../shared/object/usuario_rol.model';
import { GraphQLClient } from '../../../shared/services/graph-qlclient.service';
import { SecurityService } from '../../../shared/services/security.service';
import { ValidadoresService } from '../../../shared/validadores/validadores';

@Component({
  selector: "app-usuarios",
  templateUrl: "./usuarios.component.html",
  styleUrls: ["./usuarios.component.scss"],
  providers: [SecurityService, ValidadoresService]
})

export class UsuariosComponent implements OnInit {

  // Form
  formHeader: FormGroup
  // Constants
  readonly RB_TIPO_VISTA_RUT: Boolean = false
  readonly RB_TIPO_VISTA_NOMBRE: Boolean = true

  private client: GraphQLClient = null;
  usuarioList: Array<any> = [];
  selectedUsuario: usuario;
  selectedUsuarioRol: usuario_rol;
  usuario: usuario;
  usuario_rol: usuario_rol;
  formulario: FormGroup;
  optionsRol: Array<any> = [];
  optionsUsuarioRol: Array<any> = [];
  optionsSucursal: Array<any> = [];
  rolList: rol[];
  sucursalList: sucursal[];
  usuarioSucursalList: sucursal_usuarioJoin[];
  selectedSucursalUsuario: sucursal_usuario;
  public rut_empresa;
  public roles_codigo: Array<any> = [];
  public sucursal_codigo: Array<any> = [];
  public options: boolean = true;
  public nombre: string;
  public rut: 0;
  @ViewChild('agregarUsuario', { static: true }) agregarModal: ModalDirective;
  @ViewChild('editarUsuario', { static: true }) editarModal: ModalDirective;
  public codgo_modulo: number = 20;
  public rut_usuario = Number(this.accesolocalstorage.getRutUsuario());
  fieldTextType: boolean = true;
  ConfirmPassHidden: boolean = true;

  constructor(client: GraphQLClient,
    private formBuilder: FormBuilder,
    private accesolocalstorage: SecurityService,
    private rutService: RutService,
    private rutValidator: RutValidator,
    private usuarioSerive: UsuarioService,
    private messageRendererService: MessageRendererService,
    private toastService: ToastService,
    public validadores: ValidadoresService) {
    this.client = client;
    this.buildForm();
  }

  buildForm() {
    this.formHeader = this.formBuilder.group({
      tipoVista: [this.RB_TIPO_VISTA_NOMBRE],
      rut_user: [null],
      nombre_usuario: [null],
      roles_codigo: [[]],
      sucursal_codigo: [[]],
      activo: [true],
    });

    this.formulario = this.formBuilder.group({
      rut_usuario: ['', [Validators.minLength(7), Validators.maxLength(13), Validators.required, this.rutValidator]],
      login: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(20)]],
      password: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(15)]],
      confirmarpass: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(15)]],
      mail: ['', [Validators.required, Validators.email]],
      activo: true,
      nombre_completo: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(100)]],
      flag_cambioclave: [''],
      rol: ['', [Validators.required]],
      sucursal: [''],
      max_sesiones: [1, [Validators.min(1), Validators.max(100)]],
    });
    this.formulario.valueChanges.subscribe(field => {
      if (field.password !== field.confirmarpass) {
        this.formulario.controls["confirmarpass"].setErrors({ mismatch: true });
      } else {
        this.formulario.controls["confirmarpass"].setErrors(null);
      }
    });
  }

  ngOnInit() {
    this.selectedUsuario = {
      rut_usuario: null,
      login: '',
      password: '',
      fecha_creacion: new Date(),
      fecha_modificacion: new Date(),
      mail: '',
      activo: true,
      nombre_completo: '',
      flag_cambioclave: true,
      max_conexiones_concurrentes: 1
    };

    this.selectedUsuarioRol = {
      rut_usuario: null,
      roles_codigo: null,
      fecha_asignacion: new Date(),
    };

    this.selectedSucursalUsuario = {
      rut_empresa: null,
      sucursal_codigo: null,
      fecha_asignacion: new Date(),
      rut_usuario: null
    };
    this.rut_empresa = this.accesolocalstorage.getRutEmpresa();
    this.obtenerSucursalxEmpresa(this.rut_empresa);
    // this.obtenerDatosUsuario();
    this.obtenerRoles();
  }

  showNew() {
    this.formulario.reset();
    this.formulario.get('activo').setValue(true);
    this.formulario.get('rut_usuario').enable();
    this.formulario.get('login').enable();
    this.formulario.get('max_sesiones').setValue(1);
    this.usuarioSucursalList = [];
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  ShowAndHiddenConfirmPass() {
    this.ConfirmPassHidden = !this.ConfirmPassHidden;
  }

  showForEdit(usuario: usuario) {
    this.formulario.get('rut_usuario').setValue(this.validadores._enmascaraRut(String(usuario.rut_usuario)));
    this.formulario.get('rut_usuario').disable();
    this.formulario.get('login').setValue(usuario.login);
    this.formulario.get('login').disable();
    this.formulario.get('password').setValue(usuario.password);
    this.formulario.get('confirmarpass').setValue(usuario.password);
    this.formulario.get('mail').setValue(usuario.mail);
    this.formulario.get('activo').setValue(usuario.activo);
    this.formulario.get('nombre_completo').setValue(usuario.nombre_completo);
    this.formulario.get('flag_cambioclave').setValue(usuario.flag_cambioclave);
    this.formulario.get('max_sesiones').setValue(usuario.max_conexiones_concurrentes);
    this.formulario.get('rol').setValue('');
    this.obtenerUsuarioRol(usuario.rut_usuario);
    this.obtenerUsuarioSucursal(usuario.rut_usuario);
    console.log(this.formulario);
  }

  obtenerDatosUsuario() {
    let self = this;
    self.rut_empresa = self.accesolocalstorage.getRutEmpresa();
    self.client.query({
      query: gql`
      query($rut_empresa:Decimal){
        usuario{
          obtenerTodosUsuarioxEmpresa(rut_empresa:$rut_empresa){
            respuesta{
              registros{
                rut_usuario
                login
                fecha_creacion
                fecha_modificacion
                mail
                activo
                nombre_completo
                flag_cambioclave
                max_conexiones_concurrentes
              }
            }
          }
        }
      }
      `,
      variables: {
        'rut_empresa': self.rut_empresa,
      },
      fetchPolicy: 'no-cache',
    },
      function (respuesta) {
        console.log(respuesta);
        self.usuarioList = respuesta.data.usuario.obtenerTodosUsuarioxEmpresa.respuesta.registros;
        self.usuarioList.forEach((doc, index) => {
          doc.rutFormato = self.rutService.AgregarDV(doc.rut_usuario)
        })
      });


  }

  ValidaQueExisteDatosUsuario(usuario_SucursalList: sucursal_usuarioJoin[]) {
    let self = this; // this is unused
    var usu: usuario = new usuario();
    usu.rut_usuario = Number(this.validadores._desenmascaraRutyQuitaDV(this.formulario.controls["rut_usuario"].value));
    usu.login = this.formulario.controls["login"].value;
    this.client.query({
      query: gql`
        query($entidad: usuarioInputType){
          usuario{
            existe(entidad:$entidad){
              respuesta
            }
          }
        }
        `,
      fetchPolicy: 'network-only',
      variables: {
        "entidad": usu
      },
    },
      function (respuesta) {

        if (respuesta.data.usuario.existe.respuesta) {
          var res = window.confirm("El Usuario ingresado ya existe. ¿Desea sobreescribirlo?");
          if (res) {
            self.actualizar(usuario_SucursalList);
          }
        }
        else {
          self.insertar(usuario_SucursalList);
        }
      }
    );
  }

  insertar(usuario_SucursalList: sucursal_usuarioJoin[]) {
    this.selectedUsuario.rut_usuario = Number(this.validadores._desenmascaraRutyQuitaDV(this.formulario.controls["rut_usuario"].value));
    this.selectedUsuario.login = this.formulario.controls["login"].value;
    this.selectedUsuario.password = this.formulario.controls["password"].value;
    this.selectedUsuario.mail = this.formulario.controls["mail"].value;
    this.selectedUsuario.activo = this.formulario.controls["activo"].value;
    this.selectedUsuario.nombre_completo = this.formulario.controls["nombre_completo"].value;
    this.selectedUsuario.max_conexiones_concurrentes = this.formulario.controls["max_sesiones"].value;
    this.selectedUsuario.flag_cambioclave = true;
    this.postUsuario(this.selectedUsuario);
    this.actualizarRol();
    this.refrescarSucursal(usuario_SucursalList);
  }

  postUsuario(usuario: usuario) {
    let self = this;
    var bodyx = usuario;
    this.client.mutate({
      mutation: gql`
      mutation($entidad: usuarioInputType)
      {
        usuario
        {
          agregar(entidad: $entidad) {
            respuesta{
              rut_usuario
              login
              password
              fecha_creacion
              fecha_modificacion
              mail
              activo
              nombre_completo
              flag_cambioclave
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.usuario.agregar.respuesta != undefined) {
          setTimeout(() => self.obtenerDatosUsuario(), 1000);
        }
      });
  }

  actualizar(usuario_SucursalList: sucursal_usuarioJoin[]) {
    this.selectedUsuario.rut_usuario = Number(this.validadores._desenmascaraRutyQuitaDV(this.formulario.controls["rut_usuario"].value));
    this.selectedUsuario.login = this.formulario.controls["login"].value;
    this.selectedUsuario.password = this.formulario.controls["password"].value;
    this.selectedUsuario.mail = this.formulario.controls["mail"].value;
    this.selectedUsuario.activo = this.formulario.controls["activo"].value;
    this.selectedUsuario.nombre_completo = this.formulario.controls["nombre_completo"].value;
    this.selectedUsuario.flag_cambioclave = this.formulario.controls["flag_cambioclave"].value;
    this.selectedUsuario.max_conexiones_concurrentes = this.formulario.controls["max_sesiones"].value;
    this.refrescar(this.selectedUsuario);
    this.actualizarRol();
    this.refrescarSucursal(usuario_SucursalList);
  }

  actualizarRol() {
    this.selectedUsuarioRol.rut_usuario = Number(this.validadores._desenmascaraRutyQuitaDV(this.formulario.controls["rut_usuario"].value));
    let valor = this.formulario.controls["rol"].value;
    if (valor[0] == undefined) {
      this.selectedUsuarioRol.roles_codigo = this.formulario.controls["rol"].value;
    } else {
      this.selectedUsuarioRol.roles_codigo = valor[0];
    }
    this.refrescarRol(this.selectedUsuarioRol);

  }

  refrescar(usuario: usuario) {
    let self = this;
    var bodyx = usuario;
    delete usuario["__typename"];
    if (usuario.password == undefined) {
      usuario.password = "";
    }
    this.client.mutate({
      mutation: gql`
      mutation($entidad: usuarioInputType)
      {
        usuario
        {
          modificar(entidad: $entidad) {
            respuesta{
              rut_usuario
              login
              password
              fecha_creacion
              fecha_modificacion
              mail
              activo
              nombre_completo
              flag_cambioclave
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.usuario.modificar.respuesta != undefined) {
          self.toastService.success("Se ha editado el usuario satisfactoriamente.");
          setTimeout(() => self.obtenerSegunFiltroUsuarioxEmpresa(), 1000);
        }
      });
  }


  cambiaEstado(usuario: usuario) {
    if (usuario.activo) {
      usuario.activo = false;
    }
    else {
      usuario.activo = true;
    }
    this.refrescar(usuario);
  }

  obtenerSucursalxEmpresa(rut_empresa: number) {
    rut_empresa;
    let self = this;
    this.client.query({
      query: gql`
      query($rut_empresa:Decimal){
        sucursal{
          obtenerSucursalxEmpresa(rut_empresa:$rut_empresa){
            respuesta{
              registros{
                rut_empresa
                codigo
                nombre
                descripcion
                activo
                fecha_creacion
              }
            }
          }
        }
      }
      `,
      variables: {
        'rut_empresa': rut_empresa,
      },
      fetchPolicy: 'network-only',
    }, function (respuesta) {
      self.sucursalList = respuesta.data.sucursal.obtenerSucursalxEmpresa.respuesta.registros;
      self.optionsSucursal = [];
      var sel: any;
      self.sucursalList.forEach(element => {
        if (element.activo == true) {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsSucursal.push(sel);
        }
      });
    });
  }

  obtenerRoles() {
    let self = this;
    this.client.query({
      query: gql`
        query {
          rol
          {
            obtenerTodos {
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                  activado
                  fecha_creacion
                }
              }
            }
          }
        }
        `
      ,
      fetchPolicy: 'network-only',
    }, function (respuesta) {
      self.rolList = respuesta.data.rol.obtenerTodos.respuesta.registros;
      self.optionsRol = [];
      var sel: any;

      self.rolList.forEach(element => {
        if (element.activado == true) {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsRol.push(sel);
        }
      });
    });
  }

  obtenerUsuarioRol(rut_usuario: number) {
    let self = this;
    this.client.query({
      query: gql`
      query($rut_usuario:Decimal){
        rol{
          obtenerUsuarioxRol(rut_usuario:$rut_usuario){
            respuesta{
              registros{
                codigo
                nombre
                descripcion
                activado
                fecha_creacion
              }
            }
          }
        }
      }
      `,
      variables: {
        'rut_usuario': rut_usuario,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      self.rolList = [];
      self.rolList = respuesta.data.rol.obtenerUsuarioxRol.respuesta.registros;
      self.rolList.forEach(element => {
        self.formulario.controls["rol"].setValue([element.codigo]);
      });
    });
  }

  refrescarRol(usuario_rol: usuario_rol) {
    let self = this;
    var bodyx = usuario_rol;
    delete usuario_rol["__typename"];
    this.client.mutate({
      mutation: gql`
      mutation($entidad : usuario_rolInputType){
        usuario_rol{
          guardar(entidad:$entidad){
            respuesta{
              rut_usuario
              roles_codigo
              fecha_asignacion
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.usuario_rol.guardar.respuesta != undefined) {
          setTimeout(() => self.obtenerDatosUsuario(), 1000);
        }
      });
  }

  obtenerUsuarioSucursal(rut_usuario: number) {
    let self = this;
    self.rut_empresa = self.accesolocalstorage.getRutEmpresa();
    self.client.query({
      query: gql`
      query($rut_empresa:Decimal, $rut_usuario:Decimal){
        usuario{
          obtenerUsuarioxSucursal(rut_empresa:$rut_empresa, rut_usuario:$rut_usuario){
            respuesta{
              registros{
                rut_empresa
                sucursal_codigo
                nombre
                fecha_asignacion
                rut_usuario
              }
            }
          }
        }
      }
      `,
      variables: {
        'rut_empresa': self.rut_empresa,
        'rut_usuario': rut_usuario
      },
      fetchPolicy: "no-cache",
    },
      function (respuesta) {
        self.usuarioSucursalList = respuesta.data.usuario.obtenerUsuarioxSucursal.respuesta.registros;
      });
  }

  refrescarSucursal(usuario_SucursalList: sucursal_usuarioJoin[]) {
    let rut_empresa = this.accesolocalstorage.getRutEmpresa();
    let rut_usuario = Number(this.validadores._desenmascaraRutyQuitaDV(this.formulario.controls["rut_usuario"].value));
    for (var i = 0; i < usuario_SucursalList.length; i++) {
      delete usuario_SucursalList[i]["__typename"];
      delete usuario_SucursalList[i].nombre;
      usuario_SucursalList[i].rut_empresa = rut_empresa
    }
    //console.log(usuario_SucursalList);
    let self = this;
    var bodyx = usuario_SucursalList;
    this.client.mutate({
      mutation: gql`
      mutation($entidad:sucursal_usuarioListInputType, $rut_empresa:Decimal, $rut_usuario:Decimal){
        sucursal_usuario{
          guardarSucursalUsuario(entidad:$entidad, rut_empresa:$rut_empresa, rut_usuario:$rut_usuario){
            respuesta{
              rut_empresa
              fecha_asignacion
              rut_usuario
              sucursal_codigo
            }
          }
        }
      }
      `,
      variables: {
        "entidad": {
          "objet": bodyx
        },
        "rut_empresa": rut_empresa,
        "rut_usuario": rut_usuario
      }
    },
      function (mensajes) {
        if (mensajes.data.sucursal_usuario.guardarSucursalUsuario.mensajes != undefined) {
          setTimeout(() => self.obtenerUsuarioSucursal(rut_empresa), 1000);
        }
      });

  }

  agregarSucursal() {
    var sel: any;
    var arr = [];
    let sucursal_codigo = this.formulario.controls["sucursal"].value;
    let rut_empresa = 0;
    let nombre = "";
    let fecha_asignacion = new Date();
    let rut_usuario = Number(this.validadores._desenmascaraRutyQuitaDV(this.formulario.controls["rut_usuario"].value));
    if (sucursal_codigo == null) {
      return;
    }
    this.sucursalList.forEach(element => {
      if (element.codigo == sucursal_codigo) {
        nombre = element.nombre;
      }
    });

    for (let item of this.usuarioSucursalList) {
      arr = [item["sucursal_codigo"], item["nombre"]];
      var idx = arr.indexOf(sucursal_codigo);
      if (idx != -1) {
        return;
      }
    }
    sel = { rut_empresa, sucursal_codigo, nombre, fecha_asignacion, rut_usuario };
    this.usuarioSucursalList.push(sel);
  }

  eliminarSucursal(index) {
    this.usuarioSucursalList.splice(index, 1);
  }

  obtenerSegunFiltroUsuarioxEmpresa() {

    const filtro_rut = this.formHeader.get('rut_user').value != undefined ? this.rutService.QuitarDV(
      this.rutService.Limpiar(this.formHeader.get('rut_user').value)) : null;

    const filtro_nombre = this.formHeader.get('nombre_usuario').value != undefined ? this.formHeader.get('nombre_usuario').value : null;

    const sucursal = this.formHeader.get('sucursal_codigo').value;
    const roles = this.formHeader.get('roles_codigo').value;

    this.usuarioList = [];
    let rut_empresa = this.accesolocalstorage.getRutEmpresa();
    let activado = this.formHeader.get('activo').value;


    const inputParams = {
      entidad: {
        rut_usuario: Number(filtro_rut),
        login: '',
        password: '',
        fecha_creacion: new Date(),
        fecha_modificacion: new Date(),
        mail: '',
        activo: activado,
        nombre_completo: filtro_nombre,
        flag_cambioclave: true
      },
      rut_empresa: rut_empresa,
      roles_codigo: roles,
      sucursal_codigo: sucursal
    };

    this.usuarioSerive.obtenerUsuariosxEmpresa(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      const { registros } = respuesta;
      this.usuarioList = registros;

      this.usuarioList.forEach((doc, index) => {
        doc.rutFormato = this.rutService.AgregarDV(doc.rut_usuario)
      });

    })


    //console.log(self.roles_codigo);
  }

  limpiarFiltro() {
    this.formHeader.reset();
    this.formHeader.get('tipoVista').setValue(this.RB_TIPO_VISTA_NOMBRE);
    this.usuarioList = [];
  }

  mascaraRut(evento) {
    this.validadores._mascaraRut(evento);
  }

  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  permitirCambioEstado(usuario: usuario) {
    const self = this;
    let codigo_operacion = 4
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.cambiaEstado(usuario);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
}
